import { GROUPS, ROLES, BG_BRAND_IDENTIFIER, BRAND_PROFILES, STORE_LIST, SUPERUSER_AD_GROUP } from 'constants/index';
import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loadingProfile: false,
  data: {
    logged: false,
    firstName: '',
    lastName: '',
    employeeNumber: '',
    nmid: '',
    email: '',
    role: '',
    brand: '',
    groups: [],
    isSuperUser: false,
  },
};

const storeModel = (storeNumber) => {
  const storeLocation = storeNumber ? STORE_LIST[storeNumber] : '';
  return {
    storeNumber,
    storeLocation,
  };
};

const AUDIT_IDENTIFIER = 'G_OSP_R';

const userModel = (user) => {
  const groups = user['custom:groups'] ? JSON.parse(user['custom:groups']) : [];
  const contact = user['custom:mobilePhone'] ? user['custom:mobilePhone'] : '';
  const storeNumber = user['custom:facilityID'] ? user['custom:facilityID'] : '';
  const pin = user['custom:employeeNumber'] ? user['custom:employeeNumber'] : '';
  const storeLocation = storeNumber ? STORE_LIST[storeNumber] : '';
  const group = groups[0];
  const role = group === GROUPS.STYLIST ? ROLES.STYLIST : ROLES.TESTER; // TODO: Define correct role
  const isSuperUser = groups.includes(SUPERUSER_AD_GROUP);

  let brand = '';

  if (isSuperUser && user.activeADGroup) {
    brand = user.activeADGroup.indexOf(BG_BRAND_IDENTIFIER) === 0 ? BRAND_PROFILES.BG : BRAND_PROFILES.NM;
  } else {
    const isAuditFound = groups.some((groupName) => groupName.includes(AUDIT_IDENTIFIER));

    if (!isAuditFound) {
      const isBGBrandFound = groups.some((groupName) => groupName.includes(BG_BRAND_IDENTIFIER));
      brand = isBGBrandFound ? BRAND_PROFILES.BG : BRAND_PROFILES.NM;
    }
  }

  return {
    email: user.email,
    firstName: user.given_name,
    lastName: user.family_name,
    employeeNumber: user['custom:employeeNumber'],
    nmid: user['custom:nmid'],
    brand,
    role,
    contact,
    storeNumber,
    storeLocation,
    pin,
    isSuperUser,
    groups,
  };
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.SIGN_OUT: {
      return {
        ...INITIAL_STATE,
      };
    }

    case actionTypes.SET_USER: {
      return {
        ...state,
        data: {
          ...state.data,
          ...userModel(action.payload),
          logged: true,
        },
      };
    }

    case actionTypes.SET_STORE_NUMBER: {
      return {
        ...state,
        data: {
          ...state.data,
          ...storeModel(action.payload.storeNumber),
        },
      };
    }

    case actionTypes.SET_ACTIVE_USER_AD_GROUP: {
      return {
        ...state,
        data: {
          ...state.data,
          brand: action.payload.indexOf(BG_BRAND_IDENTIFIER) === 0 ? BRAND_PROFILES.BG : BRAND_PROFILES.NM,
        },
      };
    }

    default:
      return state;
  }
}
